import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { API } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = lädt, null = Gast

  useEffect(() => {
    if (!window.location.pathname.startsWith("/admin")) {
      setUser(null);
      return;
    }
    API.get("/admin/auth/me")
      .then((res) => setUser(res.data.user))
      .catch(() => setUser(null));
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await API.post("/admin/auth/login", { email, password });
    setUser(res.data.user);
    return res.data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      await API.post("/admin/auth/logout");
    } finally {
      setUser(null);
    }
  }, []);

  const value = useMemo(() => ({ user, login, logout }), [user, login, logout]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
